import { render, staticRenderFns } from "./voiceCall.vue?vue&type=template&id=71dfc30c&scoped=true"
import script from "./voiceCall.vue?vue&type=script&lang=js"
export * from "./voiceCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfc30c",
  null
  
)

export default component.exports